import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Config } from "../../Config";
import profileKey from "../../assets/images/profile/profileKey.png";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { removeUser, emptyCart } from "../../Redux/Actions";
import Spinner from "../Spinner/Spinner";
import "./ProfileChangePassword.scss";

const ProfileChangePassword = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  // const [phoneNumber, setPhoneNumber] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isResponseTrue, setisResponseTrue] = useState(false);
  const sendPhoneNumberHandler = (event, btn) => {
    event.preventDefault();
    btn.target.classList.add("blurInput");
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${user[0].token}`);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(Config.apiPath + "/sendOTPCode", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          toast.success(<div>{result.messages}</div>);
          setisResponseTrue(true);
        } else if (result.status === 90) {
          toast.success(<div>{result.messages}</div>);
          setisResponseTrue(true);
        } else {
          toast.error(<div>{result.messages}</div>);
        }
        btn.target.classList.remove("blurInput");
      })
      .catch((error) => {
        btn.target.classList.remove("blurInput");
      });
  };
  const setNewPasswordHandler = (event, btn) => {
    event.preventDefault();
    if (newPassword.length < 6 || confirmPassword.length < 6) {
      toast.error("کلمه عبور باید حداقل شامل 6 کاراکتر باشد");
      return;
    }
    btn.target.classList.add("blurInput");
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${user[0].token}`);
    let raw = JSON.stringify({
      // UserName: phoneNumber,
      ActiveCode: otpCode,
      Password: newPassword,
      PasswordConfirm: confirmPassword,
    });
    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(Config.apiPath + "/ResetPasswordFLU", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          btn.target.classList.remove("blurInput");
          toast.success(<div>{result.messages}</div>);
          toast.info("لطفا مجددا وارد حساب کاربری خود شوید");
          if (dispatch(removeUser(user[0]))) {
            dispatch(emptyCart(cart));
            document.cookie = "rememberMe=false;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
          }
          setTimeout(() => {
            props.history.push("/login");
          }, 5000);
        } else {
          btn.target.classList.remove("blurInput");
          toast.error(<div>{result.messages}</div>);
        }
      })
      .catch((error) => {
        btn.target.classList.remove("blurInput");
        // console.log(error);
      });
  };
  return (
    <div className="ProfileChangePassword">
      <form className="formWrapper">
        <span className="formHeader">تغییر کلمه عبور با شماره تلفن همراه</span>
        <div className={`formInput specialFormInput ${isResponseTrue ? "blurInput" : ""}`}>
          <div className="buttonAndInput">
            <button
              className={`submit ${isResponseTrue ? "submitBlurInput" : ""}`}
              onClick={(e) => sendPhoneNumberHandler(e, e)}
            >
              دریافت رمز یکبار مصرف
            </button>
          </div>
        </div>
        <div className="inputsWrapper">
          <div className={`formInput otpForm ${isResponseTrue ? "" : "blurInput"}`}>
            <label className="formLabel">کد پیامکی</label>
            <input
              className="input"
              type="text"
              value={otpCode}
              onChange={(e) => {
                setOtpCode(e.target.value.replace(" ", ""));
              }}
            />
          </div>
          <div className={`formInput passwordForm ${isResponseTrue ? "" : "blurInput"}`}>
            <label className="formLabel">کلمه عبور</label>
            <input
              className="input"
              type="password"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value.replace(" ", ""));
              }}
            />
          </div>
          <div className={`formInput passwordForm ${isResponseTrue ? "" : "blurInput"}`}>
            <label className="formLabel">تکرار کلمه عبور</label>
            <input
              className="input"
              type="password"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value.replace(" ", ""));
              }}
            />
          </div>
        </div>
        <button className={`submit ${isResponseTrue ? "" : "blurInput"}`} onClick={(e) => setNewPasswordHandler(e, e)}>
          ثبت
        </button>
      </form>
      <div className="imagFigure">
        <img src={profileKey} alt="profileKey" />
      </div>
    </div>
  );
};

export default React.memo(withRouter(ProfileChangePassword));
